import React, { Component, Fragment } from 'react';
import '../../../assets/css/fullcalendar.min.css'
import FullCalendar from 'fullcalendar-reactwrapper';
import moment from 'moment';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../../assets/css/slider.css';
import { convertTwoDecimalPoint, getItemizedAccess, getLoginModuleAccess, gradeTextToNumber, groupBy, _addNotificationError } from '../../../server/util';
import { MealTypes, MenuOrderTypes } from '../../../server/constants.js';
import MonthCalender from '../../Misc/calender/monthCalender/monthCalender';
import '../../Misc/calender/monthCalender/monthCalender.css';
import $ from 'jquery';
import CounterComponent from './CounterComponent';
import { newCategories } from './orderCalender.jsx';
const MealTypesText = {
    MEAL: 'Main course',
    SNACK: 'Snack',
    DINNER: 'Dinner',
    BREAKFAST: 'Breakfast',
    SIDE: 'Sides',
    EXTRA: 'A La Carte ',
    HOLIDAY: 'Holiday',
    ENTREE: "Entree",
    FRUIT: 'Fruit',
    MILK: 'Milk',
    VEGETABLES: "Vegetables"
}
const MTypes = {
    meal: 'MEAL',
    snack: 'SNACK',
    dinner: 'DINNER',
    breakfast: 'BREAKFAST',
    side: 'SIDE',
    extra: 'EXTRA',
    holiday: 'HOLIDAY',
    entree: "ENTREE",
    fruit: "FRUIT",
    milk: "MILK",
    vegetables: "VEGETABLES",
};

class ReviewMenu extends Component {
    constructor(props) {
        super(props);

        let schoolID = 0
        if (this.props.isParent) {
            console.log("school id-==============", this.props.studentData.mealSchoolId)
            schoolID = this.props.studentData.mealSchoolId

        }
        const isItemized = getItemizedAccess(schoolID)
        this.state = {
            activeSlide: 0,
            isItemized
        }
    }
    eventStyles = (event, element, view) => {
        const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((event.type === MealTypes.BREAKFAST.toUpperCase()) && this.props.studentData.beforeCare) ? true : false);
        const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
        if (event.type === "MEAL" || event.type === MenuOrderTypes.ITEMIZE.toUpperCase() ||
            event.type === MealTypes.SNACK.toUpperCase() || event.type === MealTypes.BREAKFAST.toUpperCase() || event.type === MealTypes.DINNER.toUpperCase()) {
            return $('<div style="cursor:pointer;height:auto;background-color:inherit;border-radius:25px;' +
                'white-space: pre-wrap;color: black;font-size:13px;padding: 8px 14px;font-weight: bolder;margin-bottom: 5px">'
                + event.title + "  " + this.props.currency_symbol
                + (studentIsFreeMeal ? 0 : (studentIsReducePrice) ? event.reducedPrice : event.price) + '</div>');
        }
        else if (event.type === "SIDE") {
            return $('<div style="cursor:pointer;height:auto;background-color:inherit;border-radius:25px;' +
                'white-space: pre-wrap;color: red;font-size:12px;padding: 8px 14px;font-weight: bolder;margin-bottom: 5px"> S :' + " "
                + event.title + "  " + this.props.currency_symbol +
                event.price + '</div>');
            /*  element.css('background-color', 'inherit');
             element.css('border', '0px');
             element.css('font-weight', 'bolder');
             element.css('white-space', 'pre-wrap');
             element.css('color', 'red');
             element.css('font-size', '12px');
             element.css(' margin-bottom', '-5px'); */
        }
        else if (event.type === "EXTRA" || event.type === MenuOrderTypes.ITEMIZE.toUpperCase() ||
            event.type === MealTypes.SNACK.toUpperCase() || event.type === MealTypes.BREAKFAST.toUpperCase()) {
            return $('<div style="cursor:pointer;height:auto;background-color:inherit;border-radius:25px;' +
                'white-space: pre-wrap;color: #5cb85c;font-size:13px;padding: 8px 14px;font-weight: bolder;margin-bottom: 5px"> E :' + " "
                + event.title + "  " + this.props.currency_symbol +
                event.price + '</div>');
        }
        else {
            element.css('background-color', 'inherit');
            element.css('color', 'black');
            element.css('border', '0px');
        }
    }
    filterSelectedItems = (list = []) => {
        let menuItems = [];
        let _list = list.map(item => {
            item.sdate = moment(item.start).format('YYYYMMDD');
            return item;
        })
        let groupList = groupBy(list, 'sdate');
        Object.keys(groupList).forEach(date => {
            const mealSelect = groupList[date].some(itm => {
                if (itm.type === 'HOLIDAY') {
                    return true;
                } else {
                    return itm.isSelected && (newCategories.includes(itm.type) || itm.type == 'MEAL' || itm.type == 'EXTRA' || itm.type === MenuOrderTypes.ITEMIZE.toUpperCase() ||
                        itm.type === MealTypes.SNACK.toUpperCase() || itm.type === MealTypes.BREAKFAST.toUpperCase() || itm.type === MealTypes.DINNER.toUpperCase())
                }
            })
            if (mealSelect) {
                groupList[date].map(m => {
                    if (m.isSelected || m.type === 'HOLIDAY') {
                        menuItems.push(m);
                    }
                });
            }
        })
        return menuItems;
    }
    renderDayEventList = (eventsObj, eventDate) => {
        const currency = this.props.currency_symbol;
        console.log(eventsObj, "review order...")
        return (
            <Fragment>
                {
                    (eventsObj[MTypes.meal] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.meal]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.meal] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                    const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && this.props.studentData.beforeCare) ? true : false);
                                    const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (<div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                        <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}><div className={item.isSelected ? "menuItem border noAction" : "menuItem"}
                                            style={allergy ? { backgroundColor: '#e5710d' } : {}}>{
                                                allergy ?
                                                    <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.price : item.price))}`}</span></a> :
                                                    <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.price : item.price))}`}</span>
                                            }</div></div>
                                        {((this.state.isItemized === 1 || this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={true} updateQuantity={() => { }} item={item} /> </div>}
                                    </div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    Object.keys(eventsObj).map(keyName => {
                        if (!newCategories.includes(keyName)) {
                            return null
                        }
                        const menuList = eventsObj[keyName] || []
                        return (menuList || []).length > 0 ?
                            <Fragment>
                                <p className="groupTitle">
                                    <small>{MealTypesText[keyName]}</small>
                                    <hr className="menuItemDivision" />
                                </p>
                                {
                                    (menuList || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                        const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && this.props.studentData.beforeCare) ? true : false);
                                        const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
                                        const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                        return (<div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                            <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}><div className={item.isSelected ? "menuItem border noAction" : "menuItem"}
                                                style={allergy ? { backgroundColor: '#e5710d' } : {}}>{
                                                    allergy ?
                                                        <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.price : item.price))}`}</span></a> :
                                                        <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.price : item.price))}`}</span>
                                                }</div></div>
                                            {((this.state.isItemized === 1 || this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={true} updateQuantity={() => { }} item={item} /> </div>}
                                        </div>)
                                    })
                                }
                            </Fragment> : null
                    })
                }
                {
                    (eventsObj[MTypes.snack] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.snack]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.snack] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                    const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && this.props.studentData.beforeCare) ? true : false);
                                    const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (<div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                        <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}>
                                            <div className={item.isSelected ? ("menuItem border") : ("menuItem")}
                                                style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                                    allergy ?
                                                        <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.price : item.price))}`}</span></a> :
                                                        <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.price : item.price))}`}</span>
                                                }</div></div>
                                        {((this.state.isItemized === 1 || this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={true} updateQuantity={() => { }} item={item} /> </div>}</div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.dinner] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.dinner]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.dinner] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                    const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && this.props.studentData.beforeCare) ? true : false);
                                    const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (<div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                        <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}>
                                            <div className={item.isSelected ? ("menuItem border") : ("menuItem")}
                                                style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                                    allergy ?
                                                        <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.price : item.price))}`}</span></a> :
                                                        <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.price : item.price))}`}</span>
                                                }</div></div>
                                        {((this.state.isItemized === 1 || this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={true} updateQuantity={() => { }} item={item} /> </div>}</div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.breakfast] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.breakfast]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.breakfast] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                    const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && this.props.studentData.beforeCare) ? true : false);
                                    const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (<div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                        <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}>
                                            <div className={item.isSelected ? ("menuItem border") : ("menuItem")}
                                                style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                                    allergy ?
                                                        <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.price : item.price))}`}</span></a> :
                                                        <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.price : item.price))}`}</span>
                                                }</div></div>
                                        {((this.state.isItemized === 1 || this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={true} updateQuantity={() => { }} item={item} /> </div>}</div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.side] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.side]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.side] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (
                                        item.isSideSelect ?
                                            <div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                                <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}>
                                                    <div className={item.isSelected ? ("menuItem border noAction") : ("menuItem")}
                                                        style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                                            allergy ?
                                                                <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${convertTwoDecimalPoint(item.price)}`}</span></a> :
                                                                <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(item.price)}`}</span>
                                                        }</div></div>
                                                {((this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={true} updateQuantity={() => { }} item={item} /> </div>}
                                            </div> :
                                            <div className={'menuItem border noAction'}>
                                                <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(item.price)}`}</span>
                                            </div>
                                    )
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.extra] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.extra]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.extra] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (
                                        <div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                            <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}>
                                                <div className={item.isSelected ? ("menuItem border noAction") : ("menuItem")}
                                                    style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                                        allergy ?
                                                            <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${convertTwoDecimalPoint(item.price)}`}</span></a> :
                                                            <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(item.price)}`}</span>
                                                    }</div></div>
                                            {((this.state.isItemized === 2 || this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={true} updateQuantity={() => { }} item={item} /> </div>}
                                        </div>
                                    )
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.holiday] || []).length > 0 ?

                        (eventsObj[MTypes.holiday] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                            return <div className={"menuItem noSchool"}>
                                <span>{item.name}</span></div>
                        })
                        : null
                }
            </Fragment>);
    }
    next(device = 'D') {
        if (device == 'M') {
            let aSlide = this.state.activeSlide;
            aSlide++;
            if (Object.keys(this.props.dataSet).length > aSlide) {
                this.setState({ activeSlide: aSlide })
            }
        }
        else {
            this.slider.slickNext();
        }
    }
    previous(device = 'D') {
        if (device == 'M') {
            let aSlide = this.state.activeSlide
            if (aSlide > 0) {
                aSlide--;
                this.setState({ activeSlide: aSlide })
            }
        } else {
            this.slider.slickPrev();
        }
    }
    scrollTop = () => {
        const _pageTop = document.getElementById('pageTop')
        if (_pageTop) {
            if (_pageTop.parentElement)
                _pageTop.parentElement.scrollTo(_pageTop.parentElement.scrollX, 0);
        }
    }
    render() {
        const settings = {
            dots: false,
            arrows: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: true,
            beforeChange: (current, next) => {
                this.setState({ activeSlide: next })
            },
            afterChange: (current) => {
                this.setState({ activeSlide: current });
            }
        };
        const { dataSet } = this.props;
        const gradeGroup = groupBy(this.props.gradeList || [], 'value');
        return (
            <Fragment>

                {/* <div id="myID" className="bottomMenu show">
                    <p className="text-center"
                        style={{color: 'darkblue', fontSize: '12px'}}>
                        Order Amount : <span style={{fontSize: '20px'}}>{this.props.currency_symbol+''+parseFloat(this.props.price[Object.keys(dataSet)[this.state.activeSlide]]).toFixed(2)} </span></p>
                </div> */}
                {
                    window.innerWidth <= 500 ?
                        <Fragment>

                            {
                                Object.keys(dataSet || {}).map((yearMonth, i) => {
                                    return (<Fragment>
                                        {
                                            i == this.state.activeSlide ?
                                                <div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="text-left" style={{ margin: '10px' }}>
                                                                <h4 style={{ marginBottom: '3px' }}>{moment(yearMonth, 'YYYYMM').format('MMMM-YYYY')}</h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        this.props.paymentProcessPendingBox()
                                                    }
                                                    <div className="row">
                                                        <div className="col-md-12 text-center" style={{ display: "flex", justifyContent: "end" }}>
                                                            <button type="button" className="btn btn-sm btn-info pull-left" style={{ margin: '7px', width: '100%' }} onClick={(e) => {
                                                                if (this.state.activeSlide <= 0) {
                                                                    this.props.onBackReview(e);
                                                                } else {
                                                                    this.previous('M');
                                                                }
                                                                this.scrollTop();
                                                            }}>Back to Menu</button>
                                                        </div>
                                                        <div className="col-md-12 text-center" style={{ display: "flex", justifyContent: "end" }}>

                                                            <button type="button" className="btn btn-sm btn-success pull-right" style={{ margin: '7px', width: '100%' }} onClick={(e) => {
                                                                if (Object.keys(dataSet).length > 1 && this.state.activeSlide < Object.keys(dataSet).length - 1) {
                                                                    this.next('M');
                                                                } else {
                                                                    this.props.onSubmitOrderReviewSelection(e)
                                                                }
                                                                this.scrollTop()
                                                            }}>{this.state.activeSlide >= Object.keys(dataSet).length - 1 ? 'Go to Payment Summary' : 'Next Review Order'}
                                                            </button>
                                                        </div>
                                                        <div className="col-md-12 text-center">
                                                            <div id="myID" className="bottomMenu show">

                                                                <ul style={{ display: 'inline-flex' }}>
                                                                    <li style={{ paddingRight: '10px', borderRight: '1px solid #ddd' }}>
                                                                        <p className="text-center"
                                                                            style={{ color: '#aa6331', fontSize: '12px', marginBottom: '0px' }}>
                                                                            Paid Amount : <span style={{ fontSize: '20px' }}>{this.props.currency_symbol + '' + parseFloat(this.props.initialPrices[Object.keys(dataSet)[this.state.activeSlide]]).toFixed(2)} </span></p>
                                                                    </li>
                                                                    <li style={{ paddingLeft: '5px' }}>
                                                                        <p className="text-center"
                                                                            style={{ color: 'darkblue', fontSize: '12px', marginBottom: '0px' }}>
                                                                            Order Amount : <span style={{ fontSize: '20px' }}>{this.props.currency_symbol + '' + (parseFloat(this.props.price[Object.keys(dataSet)[this.state.activeSlide]]) - parseFloat(this.props.initialPrices[Object.keys(dataSet)[this.state.activeSlide]])).toFixed(2)} </span></p>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">

                                                            <div className="table-responsive">
                                                                {/* <FullCalendar id={`mCal-${yearMonth}`}
                                            ref={(c)=>{this[`ref${yearMonth}`]=c}}
                                            height="auto"
                                            defaultDate={moment(yearMonth,'YYYYMM').toDate()}
                                        // weekends={false}
                                            themeSystem='bootstrap3'
                                            header={false}
                                            //weekends={false}
                                            hiddenDays={this.props.hiddenDays}
                                            editable={false}
                                            resizable={false}
                                            //eventClick={ this.selectEvent}
                                            events={this.filterSelectedItems(dataSet[yearMonth].menuItemsList||[])}
                                            displayEventTime={false}
                                            fixedWeekCount={false}
                                            // droppable: true, // this allows things to be dropped onto the calendar
                                            eventRender={this.eventStyles}                    
                                            /> */}
                                                                <MonthCalender
                                                                    id={`cCal-${yearMonth}`}
                                                                    ref={(c) => { this[`ref-c${yearMonth}`] = c }}
                                                                    hiddenDays={this.props.hiddenDays}
                                                                    defaultDate={moment(yearMonth, 'YYYYMM')}
                                                                    events={this.filterSelectedItems(dataSet[yearMonth].menuItemsList || [])}
                                                                    //eventClick={ this.selectEvent}
                                                                    renderDayEventList={this.renderDayEventList}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : null
                                        }
                                    </Fragment>);
                                })
                            }

                        </Fragment>
                        :
                        <Slider ref={c => (this.slider = c)} {...settings}>
                            {
                                Object.keys(dataSet || {}).map((yearMonth, index) => {
                                    return <Fragment key={index}>
                                        {/* <div className="row" style={{margin: '0'}}>
                        <div className="order-meal-header capitalize">
                            <div className="col-sm-4">
                                <p>Name: <span>{this.props.studentData.firstName + ' ' + this.props.studentData.lastName}</span>
                                </p>
                            </div>
                            <div className="col-sm-6">
                                <p>School: <span>{this.props.studentData.schoolName}</span></p>
                            </div>
                            <div className="col-sm-2">
                                <p>Grade: <span>{ ((gradeGroup[this.props.studentData.gradeName]||[])[0]||{}).label||''}</span></p>
                            </div>
                            <div className="col-md-6 col-sm-6"></div>
                        </div>
                    </div> */}
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginBottom: '10px' }}>
                                                <div className="text-center" >
                                                    <h4 className="pull-left">{moment(yearMonth, 'YYYYMM').format('MMMM-YYYY')}</h4>
                                                </div>
                                            </div>
                                            <div className="col-md-8" style={{ display: "flex", justifyContent: "end" }}>
                                                <button type="button" style={{ margin: "0px 8px" }} className="btn btn-sm btn-info" onClick={(e) => {
                                                    if (this.state.activeSlide <= 0) {
                                                        this.props.onBackReview(e);
                                                    } else {
                                                        this.slider.slickPrev();
                                                    }
                                                    this.scrollTop();
                                                }}>Back to Menu</button>
                                                {/* <button type="button" className="btn btn-sm btn-success pull-right" onClick={(e)=>{
                                         if(Object.keys(dataSet).length>1 && this.state.activeSlide<Object.keys(dataSet).length-1 ){
                                            this.slider.slickNext();
                                         }else{
                                            this.props.onSubmitOrderReviewSelection(e)
                                         }                                        
                                    }}>{this.state.activeSlide>=Object.keys(dataSet).length-1?'Submit':'Next'}</button> */}
                                                <button type="button" style={{ margin: "0px 8px" }} className="btn btn-sm btn-success pull-right" onClick={(e) => {

                                                    if (Object.keys(dataSet).length > 1 && this.state.activeSlide < Object.keys(dataSet).length - 1) {
                                                        this.slider.slickNext();
                                                    } else {
                                                        if (this.props.isPaymentPending) {
                                                            _addNotificationError('Previous payment process not at completed. It is in progress. Please wait for complete the process or contact school admin.', this.props)
                                                            return false;
                                                        }
                                                        this.props.onSubmitOrderReviewSelection(e)
                                                    }
                                                    this.scrollTop();

                                                }}>{this.state.activeSlide >= Object.keys(dataSet).length - 1 ? 'Go to Payment Summary' : 'Next Review Order'}</button>
                                                <div id="myID" className="bottomMenu show">
                                                    <ul style={{ display: 'inline-flex' }}>
                                                        <li style={{ paddingRight: '10px', borderRight: '1px solid #ddd' }}>
                                                            <p className="text-center"
                                                                style={{ color: '#aa6331', fontSize: '12px', marginBottom: '0px' }}>
                                                                Paid Amount : <span style={{ fontSize: '20px' }}>{this.props.currency_symbol + '' + parseFloat(this.props.initialPrices[Object.keys(dataSet)[this.state.activeSlide]]).toFixed(2)} </span></p>
                                                        </li>
                                                        <li style={{ paddingLeft: '5px' }}>
                                                            <p className="text-center"
                                                                style={{ color: 'darkblue', fontSize: '12px', marginBottom: '0px' }}>
                                                                Order Amount : <span style={{ fontSize: '20px' }}>{this.props.currency_symbol + '' + (parseFloat(this.props.price[Object.keys(dataSet)[this.state.activeSlide]]) - parseFloat(this.props.initialPrices[Object.keys(dataSet)[this.state.activeSlide]])).toFixed(2)} </span></p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.props.paymentProcessPendingBox()
                                        }
                                        <div className="row">
                                            <div className="col-md-12">
                                                <MonthCalender
                                                    id={`cCal-${yearMonth}`}
                                                    ref={(c) => { this[`ref-c${yearMonth}`] = c }}
                                                    hiddenDays={this.props.hiddenDays}
                                                    defaultDate={moment(yearMonth, 'YYYYMM')}
                                                    events={this.filterSelectedItems(dataSet[yearMonth].menuItemsList || [])}
                                                    //eventClick={ this.selectEvent}
                                                    renderDayEventList={this.renderDayEventList}
                                                />
                                            </div>
                                        </div>

                                    </Fragment>
                                })
                            }
                        </Slider>
                }
            </Fragment>)
    }
}
export default ReviewMenu



// WEBPACK FOOTER //
// ./src/components/Parent/ManageOrders/reviewMenu.jsx